const SVG = ({ fill = 'none', width = '24', height = '24', viewBox = '0 0 24 24' }) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1 1C7.632 1 4 4.633 4 9.1a7.9 7.9 0 00.708 3.306c2.025 4.43 5.908 9.11 7.05 10.437a.451.451 0 00.683 0c1.141-1.327 5.024-6.006 7.05-10.437a7.896 7.896 0 00.708-3.306c0-4.467-3.634-8.1-8.1-8.1zm0 12.307a4.212 4.212 0 01-4.208-4.208 4.212 4.212 0 014.207-4.207 4.212 4.212 0 014.207 4.207 4.212 4.212 0 01-4.207 4.208z"
      stroke="#192043"
      strokeWidth="1.25"
    />
    <path
      d="M12.1 13.307A4.212 4.212 0 017.891 9.1a4.212 4.212 0 014.207-4.208A4.212 4.212 0 0116.306 9.1a4.212 4.212 0 01-4.207 4.207z"
      stroke="#4E546C"
      strokeWidth="1.25"
    />
  </svg>
)

export default SVG
